export const designationsData = [
  {
    title: 'Certified Real Estate Brokerage Manager',
    value: 'crb',
  },
  {
    title: 'Certified Residential Specialist',
    value: 'crs',
  },
  {
    title: 'Smart Home',
    value: 'sh',
  },
  {
    title: 'Counselor of Real Estate®',
    value: 'cre',
  },
  {
    title: 'General Accredited Appraiser',
    value: 'gaa',
  },
  {
    title: "NAR's Green Designation",
    value: 'green',
  },
  {
    title: 'Graduate, REALTOR® Institute',
    value: 'gri',
  },
  {
    title: 'Performance Management Network',
    value: 'pmn',
  },
  {
    title: 'REALTOR® Association Certified Executive',
    value: 'rce',
  },
  {
    title: 'Residential Accredited Appraiser',
    value: 'raa',
  },
  {
    title: 'Seller Representative Specialist',
    value: 'srs',
  },
  {
    title: 'Society of Industrial and Office REALTORS®',
    value: 'sior',
  },
  {
    title: 'Seniors Real Estate Specialist®',
    value: 'sres',
  },
  {
    title: 'At Home With Diversity®',
    value: 'ahwd',
  },
  {
    title: 'Broker Price Opinion Resource',
    value: 'bpor',
  },
  {
    title: 'Certified Real Estate Team Specialist',
    value: 'crets',
  },
  {
    title: 'Digital Marketing: Social Media',
    value: 'dmsm',
  },
  {
    title: 'Inside Sales Agent',
    value: 'isa',
  },
  {
    title: 'Luxury Homes Certification',
    value: 'lhc',
  },
  {
    title: 'Military Relocation Professional',
    value: 'mrp',
  },
  {
    title: 'Pricing Strategy Advisor',
    value: 'psa',
  },
  {
    title: 'Real Estate Investing',
    value: 'rei',
  },
  {
    title: 'Real Estate Negotiation Expert',
    value: 'rene',
  },
  {
    title: 'Resort & Second-Home Property Specialist',
    value: 'rsps',
  },
  {
    title: 'Short Sales & Foreclosure Resource',
    value: 'sfr',
  },
  {
    title: 'Accredited Land Consultant',
    value: 'alc',
  },
  {
    title: 'Certified International Property Specialist',
    value: 'cips',
  },
  {
    title: 'Certified Property Manager®',
    value: 'cpm',
  },
  {
    title: 'e-PRO®',
    value: 'epro',
  },
  {
    title: 'Fellow of the Real Estate Institute',
    value: 'fri',
  },
  {
    title: 'Certified Leasing Officer',
    value: 'cres',
  },
  {
    title: 'Accredited Residential Manager',
    value: 'arm',
  },
  {
    title: 'Accredited Commercial Manager',
    value: 'acom',
  },
  {
    title: 'Certified in Real Estate Finance',
    value: 'crf',
  },
  {
    title: 'Certified Residential Underwriter',
    value: 'cru',
  },
  {
    title: 'Certified Reserve Planner',
    value: 'crp',
  },
  {
    title: 'Associate Reserve Planner',
    value: 'arp',
  },
  {
    title: 'Elder Planning Counselor',
    value: 'epc',
  },
  {
    title: "Accredited Buyer's Representative",
    value: 'abr',
  },
];
